export default __webpack_public_path__ + "static/Muirfield-2c93a5ab7cfbe898ec8083a1a2f760dd.webp";